import { useParams } from "react-router-dom"
import Page from "components/Page"
import FeaturedTokenDetails from "components/FeaturedTokenDetails"
import { FeaturedProjectKey, FEATURED_PROJECTS, getFeaturedProject } from "config"

interface Props {
  projectKey: FeaturedProjectKey
}

const FeaturedTokenPage = ({ projectKey }: Props) => {
  const { tokenId } = useParams()
  const project = getFeaturedProject(projectKey) || FEATURED_PROJECTS[0]

  return (
    <Page>
      {tokenId && <FeaturedTokenDetails project={project} tokenId={tokenId} />}
    </Page>
  )
}

export default FeaturedTokenPage
